import { render, staticRenderFns } from "./HeaderActionSaveButtons.vue?vue&type=template&id=7ae20bde&scoped=true"
import script from "./HeaderActionSaveButtons.vue?vue&type=script&lang=js"
export * from "./HeaderActionSaveButtons.vue?vue&type=script&lang=js"
import style0 from "./HeaderActionSaveButtons.vue?vue&type=style&index=0&id=7ae20bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae20bde",
  null
  
)

export default component.exports